module.exports = __webpack_public_path__ + "img/per-icon.2ed887d4.png";